/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */

console.log('REACT_APP_B2C_REDIRECT_URI', process.env.REACT_APP_B2C_REDIRECT_URI);

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
    forgotPassword: 'B2C_1A_PROFILEEDIT_PASSWORD_CHANGE',
    editProfile: 'B2C_1_edit_profile_v2',
  },
  authorities: {
    signUpSignIn: {
      authority:
        'https://lastingercenter.b2clogin.com/lastingercenter.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
    },
    forgotPassword: {
      authority:
        'https://lastingercenter.b2clogin.com/lastingercenter.onmicrosoft.com/B2C_1_reset_v3',
    },
    editProfile: {
      authority:
        'https://lastingercenter.b2clogin.com/lastingercenter.onmicrosoft.com/b2c_1_edit_profile_v2',
    },
  },
  authorityDomain: 'lastingercenter.b2clogin.com',
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_DATALAGOON_UI_CLIENT_ID}`, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: process.env.REACT_APP_B2C_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_B2C_REDIRECT_URI,
    navigateToLoginRequestUrl: false, // Prevent navigation issues with popup
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    secureCookies: false, // Set to true in production with HTTPS
  },
  system: {
    tokenRenewalOffsetSeconds: 300, // Refresh token 5 minutes before expiry
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          // case LogLevel.Info:
          //     console.info(message);
          //     break;
          // case LogLevel.Verbose:
          //     console.debug(message);
          //     break;
          default:
        }
      },
    },
    windowHashTimeout: 60000, // Increase timeout for popup/redirect (60 seconds)
    iframeHashTimeout: 10000, // Increase iframe timeout (10 seconds)
    loadFrameTimeout: 10000, // Increase frame load timeout
    asyncPopups: false, // Disable async popups for better control
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [`${process.env.REACT_APP_DATALAGOON_API_SCOPES}`],
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  dataLagoonApi: {
    endpoint: `${process.env.REACT_APP_DATALAGOON_API_URI}`,
    scopes: [`${process.env.REACT_APP_DATALAGOON_API_SCOPES}`],
  },
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: [`${process.env.REACT_APP_DATALAGOON_API_SCOPES}`, 'profile'],
};
